import React, { useState } from "react";
import { EyeIcon, EyeSlashIcon } from "../../../icon/EyeIcon";

export const AuthInput = ({ name, type, label, required, value, onChange }) => {
  return (
    <div className="relative z-0 mb-6 w-full group">
      <input
        name={name}
        type={type}
        id={name}
        required={required}
        value={value}
        className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
        placeholder=" "
        onChange={onChange}
      />
      <label
        htmlFor={name}
        className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >
        {label}
      </label>
    </div>
  );
};

export const AuthPasswordInput = ({
  name,
  label,
  required,
  value,
  onChange,
}) => {
  const [show, setShow] = useState(false);

  const showHandler = () => {
    setShow(!show);
  };

  return (
    <div className="relative z-0 mb-6 w-full group">
      <input
        name={name}
        type={!show ? "password" : "text"}
        id={name}
        required={required}
        value={value}
        className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
        placeholder=" "
        onChange={onChange}
      />
      <label
        htmlFor={name}
        className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >
        {label}
      </label>

      {show ? (
        <span
          className="absolute top-3 right-1 cursor-pointer"
          onClick={showHandler}
        >
          <EyeSlashIcon />
        </span>
      ) : (
        <span
          className="absolute top-3 right-1 cursor-pointer"
          onClick={showHandler}
        >
          <EyeIcon />
        </span>
      )}
    </div>
  );
};
